import React, { useEffect, useState } from 'react'
import { jwtDecode } from "jwt-decode"
import { useAuth } from "../api/authStore"
import UserInfo from './UserInfo'
import AdminDashboard from './AdminDashboard'

const Admin = (props) => {

    const { user, getAccessTokenSilently, setToken, logout } = useAuth()
    const [isAdmin, setAdmin] = useState(false)

    const [value, setValue] = React.useState(2) // Dashboard по умолчанию

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const decoded = jwtDecode(user.access_token)

    useEffect(()=>{
        decoded.permissions.map((item)=>{
            if(item.match(/admin/)){
                setAdmin(true)
            }
        })
    },[])

    const tabs = [
        {
            id: 1,
            label: 'User Info',
            icon: '👥',
            component: <UserInfo apiClient={props.apiClient} />
        },
        {
            id: 2,
            label: 'Dashboard',
            icon: '⚡',
            component: <AdminDashboard apiClient={props.apiClient} />
        }
    ]

    if (!isAdmin) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                background: 'var(--dark-bg)'
            }}>
                <div style={{
                    textAlign: 'center',
                    padding: 'var(--spacing-2xl)',
                    background: 'var(--medium-gray)',
                    border: '1px solid var(--light-gray)',
                    borderRadius: 'var(--radius-lg)',
                    boxShadow: 'var(--shadow-card)'
                }}>
                    <div style={{
                        fontSize: '48px',
                        marginBottom: 'var(--spacing-lg)'
                    }}>
                        🔒
                    </div>
                    <h2 style={{
                        color: 'var(--text-light)',
                        fontSize: 'var(--text-2xl)',
                        fontWeight: '700',
                        marginBottom: 'var(--spacing-md)'
                    }}>
                        Access Denied
                    </h2>
                    <p style={{
                        color: 'var(--text-muted)',
                        fontSize: 'var(--text-base)',
                        margin: '0'
                    }}>
                        You don't have admin permissions to access this page.
                    </p>
                </div>
            </div>
        )
    }

    return (
        <div style={{
            width: '100%',
            minHeight: '100vh',
            background: 'var(--dark-bg)',
            padding: 'var(--spacing-md)'
        }}>
            {/* Кнопки навигации */}
            <div style={{
                display: 'flex',
                gap: 'var(--spacing-md)',
                marginBottom: 'var(--spacing-md)',
                justifyContent: 'flex-start'
            }}>
                <a
                    href="https://shop.xsocks.pro/proxies"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--spacing-sm)',
                        padding: 'var(--spacing-sm) var(--spacing-md)',
                        background: 'var(--dark-gray)',
                        color: 'var(--text-light)',
                        textDecoration: 'none',
                        borderRadius: 'var(--radius-md)',
                        border: '1px solid var(--light-gray)',
                        fontSize: 'var(--text-sm)',
                        fontWeight: '600',
                        transition: 'var(--transition-normal)',
                        cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'var(--primary-orange)'
                        e.target.style.borderColor = 'var(--primary-orange)'
                        e.target.style.color = 'var(--white)'
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'var(--dark-gray)'
                        e.target.style.borderColor = 'var(--light-gray)'
                        e.target.style.color = 'var(--text-light)'
                    }}
                >
                    🛒 Store
                </a>
                <a
                    href="https://shop.xsocks.pro/tickets"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--spacing-sm)',
                        padding: 'var(--spacing-sm) var(--spacing-md)',
                        background: 'var(--dark-gray)',
                        color: 'var(--text-light)',
                        textDecoration: 'none',
                        borderRadius: 'var(--radius-md)',
                        border: '1px solid var(--light-gray)',
                        fontSize: 'var(--text-sm)',
                        fontWeight: '600',
                        transition: 'var(--transition-normal)',
                        cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'var(--primary-orange)'
                        e.target.style.borderColor = 'var(--primary-orange)'
                        e.target.style.color = 'var(--white)'
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'var(--dark-gray)'
                        e.target.style.borderColor = 'var(--light-gray)'
                        e.target.style.color = 'var(--text-light)'
                    }}
                >
                    🎫 Tickets
                </a>
            </div>


            {/* Навигационные табы */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 'var(--spacing-lg)',
                gap: 'var(--spacing-sm)'
            }}>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setValue(tab.id)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 'var(--spacing-sm)',
                            padding: 'var(--spacing-md) var(--spacing-lg)',
                            background: value === tab.id 
                                ? 'var(--primary-orange)' 
                                : 'var(--dark-gray)',
                            color: value === tab.id 
                                ? 'var(--white)' 
                                : 'var(--text-light)',
                            border: `2px solid ${value === tab.id 
                                ? 'var(--primary-orange)' 
                                : 'var(--light-gray)'}`,
                            borderRadius: 'var(--radius-md)',
                            fontSize: 'var(--text-sm)',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'var(--transition-normal)',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                        onMouseEnter={(e) => {
                            if (value !== tab.id) {
                                e.target.style.borderColor = 'var(--primary-orange)'
                                e.target.style.color = 'var(--primary-orange)'
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (value !== tab.id) {
                                e.target.style.borderColor = 'var(--light-gray)'
                                e.target.style.color = 'var(--text-light)'
                            }
                        }}
                    >
                        <span style={{ fontSize: '18px' }}>{tab.icon}</span>
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Контент */}
            <div style={{
                background: 'var(--medium-gray)',
                border: '1px solid var(--light-gray)',
                borderRadius: 'var(--radius-lg)',
                padding: 'var(--spacing-2xl)',
                boxShadow: 'var(--shadow-card)',
                minHeight: '600px'
            }}>
                {tabs.find(tab => tab.id === value)?.component}
                </div>
        </div>
    )
}

export default Admin